module.exports = __webpack_public_path__ + "static/media/01_c_photo.5fd9cda7.jpg";